import { Text, TextProps } from '../Text';
import { ArticleImage } from './ArticleImage';
import './ArticleHeadline.scss';
import { proxyImage } from '@roc-digital/mxm-base/logic';

export interface ArticleHeadlineProps {
  size?: 'lg' | 'md' | 'sm';
  headline: string;
  image?: string;
  blurhash?: string;
  onClick?: () => void;
  children?: any;
  href?: string;
}

export function ArticleHeadline(props: ArticleHeadlineProps) {
  const image = proxyImage(props?.image, undefined, 284);
  const InnerContent = <><h3 className='article-headline flex-col flex-grow min-h-[0px] font-pragati !font-bold dark:text-white'
  style={{
    whiteSpace: 'normal'
  }}>
    <span className='clamp'>{props.headline}</span>
    {props.children}
  </h3>
  {image ? <>
    <ArticleImage
      blurhash={props.blurhash}
      height={80}
      className={`bg-gray-20 w-[80px] h-[80px] min-w-[80px] min-h-[80px] max-w-[80px] max-h-[80px]`}
      src={image}
      mini
      onClick={props.onClick}
    />
  </> : null}</>; 
  

  return props.href ? <a href={props.href} className='flex flex-row gap-3 flex-grow cursor-pointer min-h-[0px]' 
      onClick={(event) => {
        event.preventDefault();
        props.onClick ? props.onClick() : null;
      }}>
      {InnerContent}
    </a> 
  :
    <div className='flex flex-row gap-3 flex-grow cursor-pointer min-h-[0px]' 
      onClick={(event) => {
        event.preventDefault();
        props.onClick ? props.onClick() : null;
      }}>
      {InnerContent}
    </div>
  ;
}

export const ArticleTitle = ({ children, className, ...props }: TextProps) => (
  <Text {...props} className={`font-pragati !font-bold ${className} dark:text-white`}>
    {children}
  </Text>
);
